const devHostNames = [
  'localhost',
  'vercel.hivewatch-dev.com',
  'webapp.sales.hivewatch-dev.com',
  'review.vercel.hivewatch-dev.com',
  'webapp.hivewatch-dev.com',
  'vercel.app',
]

export const getIsDev = () => {
  if (typeof window !== 'undefined') {
    return devHostNames.includes(window?.location?.hostname)
  }
  return false
}

/**
 * Parses a URL to extract the path and query parameters
 * @param url - The URL to parse (e.g., '/floor-plan?floorId=f-1')
 * @returns Object containing the path and properties with query string if present
 */
export const parseUrlForTracking = (
  url: string
): { path: string; properties: Record<string, string> } => {
  const [path, queryString] = url.split('?')
  const properties: Record<string, string> = {}

  if (queryString) {
    properties.query = queryString
  }

  return { path, properties }
}
